const TITLE_LISTS = [
  { h: 'H1', variant: 'h1', size: '60px' },
  { h: 'H2', variant: 'h2', size: '48px' },
  { h: 'H3', variant: 'h3', size: '40px' },
  { h: 'H4', variant: 'h4', size: '32px' },
  { h: 'H5', variant: 'h5', size: '24px' }
]

export default TITLE_LISTS
